import DashboardBox from '../../components/DashboardBox'
import DashboardSection from '../../components/Cards/DashboardSection'
import SeniorLivingFoundationTable from '../../components/Tables/SeniorLivingFoundatonTable'

export default function SeniorLivingFoundationDashboard() {
  const title = 'Senior Living Foundation Donation History'

  return (
    <DashboardBox hasMobileFullWidth>
      <DashboardSection name={title} className='table_box_xl_device'>
        <div className='w-full h-4'></div>
        <SeniorLivingFoundationTable />
      </DashboardSection>
      <div className='table_box_mobile w-full'>
        <DashboardSection
          name={title}
          // button={
          //   <NavLink to='/submit-claim'>
          //     <div role='button' className='circle_button_icon hover:brightness-90'>
          //       <AddIcon style={{color: 'white', fontSize: '26px'}} />
          //     </div>
          //   </NavLink>
          // }
        >
          <div className='w-full h-4'></div>
        </DashboardSection>

        <SeniorLivingFoundationTable displayForMobile />
      </div>
    </DashboardBox>
  )
}
